<template>
  <v-container
    id="department"
    fluid
    tag="section"
  >
    <filter-form :filter-form="filterForm"/>
    <transaction-history-table
        :currentPage="currentPage"
        :limit="limit"
        :dataTransactions="dataTransactions"
    />
    <common-no-result
      v-if="!loading && totalItem === 0"
    />
    <v-row class="mt-4">
      <v-col
        cols="12"
        sm="6"
      />
      <v-col
        cols="12"
        sm="6"
      >
        <v-pagination
          v-if="totalItem > limit"
          v-model="currentPage"
          class="justify-sm-end"
          :length="getTotalItem(totalItem)"
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import FilterForm from './components/FilterForm.vue'
  import RepositoryFactory from '../../repositories/RepositoryFactory'
  import TransactionHistoryTable from "@/pages/history-transaction-partner/components/TransactionHistoryTable";

  const DashboardPartnerRepository = RepositoryFactory.get('dashboard_partner')
  export default {
    components: {TransactionHistoryTable, FilterForm},
    data () {
      return {
        filterForm: {
          keyword: '',
          schoolLevelIds: []
        },
        currentPage: 1,
        limit: 5,
        totalItem: 0,
        dataTransactions: [],
        loading: false,
        schoolLevels: []
      }
    },
    watch: {
      currentPage: {
        handler () {
          this.getDataTransactionHistory()
        },
      },
      limit: {
        handler () {
          if (this.currentPage === 1) {
            this.getDataTransactionHistory()
          } else {
            this.currentPage = 1
          }
        },
      },
    },
    async created () {
      this.getDataTransactionHistory()
      Bus.$on('transaction-history-filter', (filterForm) => {
        this.filterForm = filterForm
        this.currentPage = 1
        this.getDataTransactionHistory()
      })
      Bus.$on('department-list-reload', () => {
        this.getDataTransactionHistory()
      })
    },
    beforeDestroy () {
      Bus.$off('transaction-history-filter')
    },
    methods: {
      async getDataTransactionHistory () {
        this.loading = true
        const params = {
          limit: this.limit,
          page: this.currentPage - 1,
          keyword: this.filterForm.keyword,
          schoolLevelIds: this.filterForm.schoolLevelIds
        }
        const loader = this.$loading.show()
        const response = await DashboardPartnerRepository.getTransactionHistory(params)
        loader.hide()
        this.loading = false
        if (response.success) {
          this.dataTransactions = _.get(response, 'data', [])
          this.totalItem = response.totalItem
        }
      }
    },
  }
</script>
